import { hrService } from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const updateEmployeeEditOption = createServiceAsyncThunk<
  IBaseResponse,
  { user_id: number; edit_option: string }
>(
  ACTION_NAMES.UPDATE_EMPLOYEE_EDIT_OPTION,
  (employeeData) => hrService.employeeEditOptions(employeeData),
  ERROR_MESSAGES.UPDATE_EMPLOYEE_EDIT_OPTIONS_FAILURE
);

export const updateEmployeeEditOptionSlice = createGenericSlice<
  IBaseResponse,
  { user_id: number; edit_option: string }
>(SLICE_NAMES.UPDATE_EMPLOYEE_EDIT_OPTION_SLICE, updateEmployeeEditOption);

export const {
  clearError: clearUpdateEmployeeEditOptionError,
  clearSuccessMessage: clearUpdateEmployeeEditOptionSuccess,
} = updateEmployeeEditOptionSlice.actions;

export default updateEmployeeEditOptionSlice.reducer;
